import colors from './colors';
import * as Products from '../types/products';

export type ShadowsVariantsType = '0' | '10' | '15' | '20' | 'cardList' | 'cardTextOnly' | 'listItem' | 'video';

export interface ShadowsVariants {
  /** @returns `none` */
  0: string;
  /** @returns `10px 10px 0 0 rgba(0, 0, 0, 0.3)` */
  10: string;
  /** @returns `15px 15px 0 0 rgba(0, 0, 0, 0.3)` */
  15: string;
  /** @returns `20px 20px 0 0 rgba(0, 0, 0, 0.3)` */
  20: string;
  /** @returns `4px 4px 0 ${colors.coolGrey[20]}` */
  cardList: string;
  /** @returns `2px 2px 4px ${colors.coolGrey[20]}` */
  cardTextOnly: string;
  /** @returns `0 0 5px 0 rgba(0, 0, 0, 0.1)` */
  listItem: string;
  /** @returns `2px 2px 2px rgba(196, 196, 196, 0.5)` */
  nav: string;
  /** @returns `0px -4px 8px rgba(40, 44, 51, 0.15)` */
  video: string;
}

export type Shadows = ShadowsVariants & Products.Variant<ShadowsVariants>;

const base: ShadowsVariants = {
  0: 'none',
  10: '10px 10px 0 0 rgba(0, 0, 0, 0.3)',
  15: '15px 15px 0 0 rgba(0, 0, 0, 0.3)',
  20: '20px 20px 0 0 rgba(0, 0, 0, 0.3)',
  cardList: `4px 4px 0 ${colors.coolGrey[20]}`,
  cardTextOnly: `2px 2px 4px ${colors.coolGrey[20]}`,
  listItem: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
  nav: '2px 2px 2px rgba(196, 196, 196, 0.5)',
  video: '0px -4px 8px rgba(40, 44, 51, 0.15)',
};

const shadows: Shadows = {
  ...base,
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export const shadowsVariants = Object.keys(base) as ShadowsVariantsType[];

export default shadows;
